module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_110-72c6bbf220f78ddf34e34dcffb8598d2.png";